// helpers
import { lte, sum, multiply, subtract, divide } from "@/utils/helpers.js";
// 获取价格
import { getProfit } from "./utils";
// 散卖基类
import _MixinBulk from "./MixinBulk";

// helpers
// import { validate } from "@/libs/veeValidate";

export default class OceanBulk extends _MixinBulk {
  constructor(props) {
    super(props);
    this._maxRoomNum = 1; // 最大可选房间数
    this._minRoomNum = 0; // 最小可选房间数
    this.hasDiffRoomPrice = !!props.prices.sale.diff_room_price; // 是否有单房差
    this.canShareRoom = props.is_share == 1;

    // this.min_people = this.hasDiffRoomPrice ? this.min_people - 1 : this.min_people; // 最小入住人数
  }

  getBestRoomNums() {
    let { _adultNum = 0, best_adult = 1, min_people } = this;
    let minPeople = Math.max(best_adult, min_people); // 最小人数 = min(最优入住人数, 最小入住人数)
    let roomNum = divide(_adultNum, minPeople); // 房间数
    let intNum = Math.floor(roomNum); // 房间整数部分
    let floatNum = subtract(roomNum, intNum); // 房间小数部分
    // (0 < 小数部分 <= 0.5) 并且 可拼房
    if (floatNum > 0) {
      if (lte(floatNum, 0.5) && this.canShareRoom) {
        floatNum = 0.5;
      } else {
        floatNum = 1;
      }
    }
    return intNum + floatNum;
  }
  getMaxRoomNum() {
    let maxRoomNum;
    let adultNum = this._adultNum;
    let bestRoomNum = this.getBestRoomNums();
    let min_people = this.hasDiffRoomPrice
      ? this.min_people - 1
      : this.min_people;
    min_people = min_people <= 0 ? 1 : min_people;

    if (this.canShareRoom) {
      if (this.hasDiffRoomPrice) {
        maxRoomNum = Math.ceil(adultNum / min_people);
      } else {
        maxRoomNum = bestRoomNum;
      }
    } else {
      maxRoomNum = Math.ceil(adultNum / min_people);
    }
    return maxRoomNum;
  }
  getMinPeople() {
    return this.min;
  }

  // async validate() {
  //   let min_value = multiply(this._roomNum, this.min_people);
  //   let total_people = this._adultNum + this._childNum;

  //   if (this.hasDiffRoomPrice) {
  //     min_value -= 1;
  //   }
  //   const customMessages = {
  //     min_value: `每间房间最低入住${this.min_people}人,请重新选择`
  //   };
  //   this.validResult = await validate(
  //     total_people,
  //     { min_value },
  //     { customMessages }
  //   );
  // }

  get messages() {
    if (!this.roomNum) {
      return "";
    }
    if (Math.floor(this.roomNum) !== this.roomNum) {
      return "当前有1间房为拼房";
    }

    // let hasDiffRoomPrice = !!this.prices.th.diff_room_price;
    // let {roomNum} = this;
    // let min_people = this.hasDiffRoomPrice
    //   ? this.min_people - 1
    //   : this.min_people;
    // if (this.totalPeople < min_people && !this.canShareRoom) {
    //   return `每间舱房必须入住${this.min_people}人，请重新选择`;
    // }
    return "";
  }
  get roomNumStep() {
    return this.min_people === this.max_people && this.is_share === 1 ? 0.5 : 1;
  }
  get totalPeople() {
    return sum([this.adultNum, this.childNum]);
  }
  get minRoomNum() {
    return this._adultNum / this.max_adult;
  }
  get maxRoomNum() {
    return this._maxRoomNum;
  }
  get adultNum() {
    return this._adultNum;
  }
  set adultNum(adultNum) {
    this._adultNum = adultNum;
    let bestRoomNum = this.getBestRoomNums();
    // 可拼房 并且有单房差

    this._maxRoomNum = this.getMaxRoomNum();
    // console.log({bestRoomNum, maxRoomNum})

    if (bestRoomNum === 0.5) {
      this._roomNum = bestRoomNum;
      this._maxChildNum = 1;
    } else {
      this.roomNum = bestRoomNum;
    }
  }

  get childNum() {
    return this._childNum;
  }
  set childNum(val) {
    this._childNum = val;
    this.validate();
  }

  get roomNum() {
    return this._roomNum;
  }
  /**
   * 最大房间数：入住成人数/（最少入住成数-1（有单房差-1，没有单房差不减））（小数点直接舍去）
   * 最小房间数：入住成人数/最大入住成人数（小数点直接进1
   */
  set roomNum(val) {
    this._roomNum = val;

    let maxChildNum = (this._maxChildNum =
      multiply(val, this.max_people) - this.adultNum);

    this.childNum = Math.min(maxChildNum, this.childNum);

    // let totalPeopleNum = this._adultNum + this._childNu
    this.validate();
  }

  // 房间数*最优入住成人数-总入住人数（成人+儿童）
  get diffRoomPriceNum() {
    if (!this.hasDiffRoomPrice) {
      return 0;
    }

    if (!this.validResult.valid) {
      return 0;
    }

    let nums = [this._adultNum, this._childNum].reduce(
      subtract,
      multiply(this._roomNum, this.min_people)
    );

    // console.count(this.cabin_name);
    // console.log(nums, this._roomNum, this.min_people, multiply(this._roomNum, this.min_people), 'diffRoomPriceNum')
    // if (nums > 1) {
    //   return 0;
    // }
    //  this._totalRoomBedNum - this.adultNum -this.childNum; // sum();
    return nums > 0 ? nums : 0;
  }

  get totalPriceList() {
    let peoples = new Array(this.adultNum + this.childNum).fill(1);
    let len_1_2 = Math.min(this.roomNum * 2, this.totalPeople);
    let people_1_2 = peoples.slice(0, len_1_2).fill(this.prices.th.adult_price);
    let adult_3_4 = peoples
      .slice(people_1_2.length, this.adultNum)
      .fill(this.prices.th.adult34_price);
    let child_3_4 = peoples
      .slice(adult_3_4.length + len_1_2)
      .fill(this.prices.th.child34_price);
    // console.log(this.min_people);
    return [
      {
        title: "第1/2人价格",
        num: people_1_2.length,
        totalPrice: sum(people_1_2),
        profit: getProfit(
          this.prices.th.adult_price,
          this.prices.sale.adult_price,
          people_1_2.length
        )
      },
      {
        title: "第3/4人成人价",
        num: adult_3_4.length,
        totalPrice: sum(adult_3_4),
        profit: getProfit(
          this.prices.th.adult34_price,
          this.prices.sale.adult34_price,
          adult_3_4.length
        )
      },
      {
        title: "第3/4人儿童价",
        num: child_3_4.length,
        totalPrice: sum(child_3_4),
        profit: getProfit(
          this.prices.th.child34_price,
          this.prices.sale.child34_price,
          child_3_4.length
        )
      },
      {
        title: "单房差",
        num: this.diffRoomPriceNum,
        totalPrice: multiply(
          this.diffRoomPriceNum,
          this.prices.th.diff_room_price
        ),
        profit: getProfit(
          this.prices.th.diff_room_price,
          this.prices.sale.diff_room_price,
          this.diffRoomPriceNum
        )
      }
    ].filter(row => row.num);
  }
}
